import BaseModel from './BaseModel'
import {action, computed, makeObservable, observable, reaction} from 'mobx'
import {isValidPhoneNumber} from 'libphonenumber-js'
import {post} from '../common/requester'
import Schedule from "./Schedule";

export default class Team extends BaseModel {
  constructor(store) {
    super(store);
    makeObservable(this, {
      id: observable,
      name: observable,
      company_id: observable,
      sport_id: observable,
      sport: observable,
      members: observable,
      schedule: observable,
      was_validated: observable,
      is_valid: computed,
      validate: action,
      get_company_sports: action,
      setMembers: action,
      sports: observable,
      fee: observable,
      toggleHeadCoach: action
    })
    reaction(() => this.company_id, (new_id, old_id) => {
      this.get_company_sports(new_id);
    })
  }
  
  id = 0;
  name = '';
  company_id = null;
  sport_id = null;
  was_validated = false;
  sport = {};
  members = [];
  sports = [];
  schedule = new Schedule();
  fee = 0;
  
  get is_valid() {
    return this.name && this.company_id && this.sport_id && this.schedule.is_valid;
  }
  
  validate = () => {
    this.was_validated = true;
    return this.is_valid;
  }
  async get_company_sports(company_id) {
    this.setProperty('sport_id', null)
    const res = await post('company_sports', {company_id})
        .catch((err) => console.error('--company sports get error', err))
      if (res) {
        this.sports = res.sports;
        if (this.sports.length === 1) {
          this.setProperty('sport_id', this.sports[0].id)
        }
        return Promise.resolve(this.sports)
      } else {
        return Promise.reject()
      }
  }
  
  setMembers = (members) => {
    this.members = members;
  }
  
  async toggleHeadCoach(company_user_id) {
    const res = await post('company/team/toggle_head_coach', {'company_id': this.company_id, 'team_id': this.id, 'company_user_id': company_user_id})
      .catch((err) => console.error('--head coach toggle error', err))
      if (res) {
        return Promise.resolve()
      }
  }
}